import React from "react";

import { Box, Radio, Typography } from "@mui/material";

interface OptionCardProps {
  value: string;
  selected: boolean;
  onSelect: (v: string) => void;
  title: string;
  subtitle?: string;
}

/** Clickable card for mutually-exclusive choices (replaces bare radio buttons). */
export const OptionCard: React.FC<OptionCardProps> = ({ value, selected, onSelect, title, subtitle }) => (
  <Box
    onClick={() => onSelect(value)}
    sx={{
      border: "2px solid",
      borderColor: selected ? "primary.main" : "divider",
      borderRadius: 2,
      p: 3,
      cursor: "pointer",
      userSelect: "none",
      transition: "border-color 0.18s",
      "&:hover": { borderColor: "primary.light" }
    }}
  >
    <Box sx={{ display: "flex", alignItems: "flex-start", gap: 2 }}>
      <Radio checked={selected} onChange={() => onSelect(value)} sx={{ p: 0, mt: 0.2 }} tabIndex={-1} />
      <Box>
        <Typography
          variant="subtitle2"
          fontWeight={selected ? 700 : 500}
          color={selected ? "primary.main" : "text.primary"}
        >
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="caption" color="text.secondary" display="block" mt={0.5}>
            {subtitle}
          </Typography>
        )}
      </Box>
    </Box>
  </Box>
);
